const ICONS = 'https://cdn.jsdelivr.net/npm/@lobehub/icons-static-svg@1.95.1/icons'

export const CUSTOM_PROVIDERS_PART03 = [
  {
    id: 'azure',
    label: 'Azure OpenAI',
    tagline: 'Your own Azure deployment',
    iconUrl: `${ICONS}/azure-color.svg`,
    keyPattern: /^[A-Za-z0-9]{32,}$/,
    keyHint: 'Azure keys are at least 32 letters and digits',
    keyUrl: 'https://portal.azure.com',
    modelLabel: 'Deployment name',
    baseUrlPlaceholder: 'https://your-resource.openai.azure.com',
    models: [],
  },
  {
    id: 'compatible',
    label: 'OpenAI-compatible',
    tagline: 'vLLM, Ollama, or any /v1 endpoint',
    iconUrl: null,
    keyPattern: /^\S{8,}$/,
    keyHint: 'Use at least 8 characters, with no spaces',
    keyUrl: null,
    baseUrlPlaceholder: 'https://llm.example.com/v1',
    models: [],
  },
]
